export enum LegalFormEnum {
    LEGAL_ENTITY,
    INDIVIDUAL_ENTREPRENEUR,
    SELF_EMPLOYEE,
}

// TODO Дополнительный enum c текстовым представлением нужен чтобы не рефакторить много кода в текущей задаче
export const LegalFormEnumMap: { [key in LegalFormEnum]: string } = {
    [LegalFormEnum.LEGAL_ENTITY]: 'LEGAL_ENTITY',
    [LegalFormEnum.INDIVIDUAL_ENTREPRENEUR]: 'INDIVIDUAL_ENTREPRENEUR',
    [LegalFormEnum.SELF_EMPLOYEE]: 'SELF_EMPLOYEE',
};